import { VariableSelector } from '@atoms/dataSelectors/variableSelector/variableSelector';
import { InputField } from '@atoms/input';
import BlockBase from '@components/dnd/base/blockBase';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { useAtom } from '@hooks/useAtom';
import EndControlsFB from '@library/formBuilder/endControls';
import { FormControl, FormLabel, Radio, RadioGroup } from '@mui/joy';
import { type DNDBlock, TO_USER_VIEW_TYPES } from '@stratumn/studio-shared';
import { type LucideIcon, UserCircle } from 'lucide-react';
import { observer } from 'mobx-react';
import type { ChangeEvent } from 'react';
import { useParams } from 'react-router-dom';
import { ParamsList } from '@/routes/routes.types';

import { initialTOUserData } from './user.data';

export const UserIcon: LucideIcon = UserCircle;

const User = (block: DNDBlock) => {
  const workflowId = useParams()[ParamsList.WorkflowId] as string;

  const atom = useAtom({
    type: 'TO_User',
    sourceId: block.id,
    parentId: workflowId,
    parentKind: 'traceOverview',
    initialData: {
      ...initialTOUserData,
      /* eslint-disable */
      selectedVariable: block.other.selectedVariableRef!
    }
  });

  if (!atom) {
    return null;
  }

  const onTitleChange = (event: ChangeEvent<HTMLInputElement>) => {
    atom.data.title = event.target.value;
  };

  return (
    <BlockBase
      dataItem={atom}
      dndBlock={block}
      endControls={
        <EndControlsFB dataItem={atom} dndBlock={block} hasRequired={false} />
      }
      icon={UserIcon}
      title={atom.data.title}
    >
      <Column>
        <InputField
          label="Widget title"
          onChange={onTitleChange}
          placeholder="Aa"
          value={atom.data.title}
        />
      </Column>
      <Column $width="200px">
        <FormControl size="sm">
          <FormLabel>State variable</FormLabel>
          <VariableSelector
            disabled
            editable={false}
            selectedRef={atom.data.selectedVariable}
          />
        </FormControl>
      </Column>
      <Column>
        <FormControl size="sm">
          <FormLabel>Display type</FormLabel>
          <RadioGroup name="radio-buttons-group" value={atom.data.viewType}>
            {TO_USER_VIEW_TYPES.map(viewtype => (
              <Radio
                color="neutral"
                key={viewtype}
                label={viewtype}
                onChange={e =>
                  (atom.data.viewType = e.target.value as typeof viewtype)
                }
                size="sm"
                value={viewtype}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Column>
    </BlockBase>
  );
};

export default observer(User);
